import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EnvelopeStatusBadgeComponent } from './envelope-status-badge.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EnvelopeStatusBadgeComponent],
  exports: [EnvelopeStatusBadgeComponent],
  providers: []
})
export class EnvelopeStatusBadgeModule {}
